import { render, staticRenderFns } from "./OrderableTextListInput.vue?vue&type=template&id=35b41912&scoped=true&"
import script from "./OrderableTextListInput.vue?vue&type=script&lang=js&"
export * from "./OrderableTextListInput.vue?vue&type=script&lang=js&"
import style0 from "./OrderableTextListInput.vue?vue&type=style&index=0&id=35b41912&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b41912",
  null
  
)

export default component.exports